import styled from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;
export const FieldLabel = styled.label`
  ${newLookType.label};
  color: ${(p) => getNewLookTokens(p.theme).secondary};
`;
export const FieldHint = styled.span`
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
`;
export const FieldInline = styled.div`
  align-self: flex-start;
`;
